const DATE_STRING_FORMAT = 'MM/dd/yyyy';
const API_DATE_STRING_FORMAT = 'yyyy-MM-dd';

export {
    DATE_STRING_FORMAT,
    API_DATE_STRING_FORMAT
};